import { minLength, maxLength, required, numeric } from 'vuelidate/lib/validators'

export const validation = {
  data () {
    return {
      fields: ['confirmCode']
    }
  },
  validations: {
    confirmCode: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(5),
      numeric
    },
  }
}
